import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'providers/auth';

import SubmitButton from 'components/ui/buttons/SubmitButton';
import withModalView from 'components/ui/withModalView';
import BotSelect from 'components/bots/BotSelect';

import TicketApi from 'api/ticket';
import NotificationHelper from 'helpers/NotificationHelper';

const AddChamadoPage = ({ backUrl }) => {
  const { t } = useTranslation();
  const { me } = useAuth();

  const history = useHistory();
  const [saving, setSaving] = useState(false);
  const [bot, setBot] = useState(false);

  const onBotChange = bot => {
    setBot(bot);
  };

  const onSubmit = async e => {
    e.preventDefault();

    const formDataObj = new FormData(e.target);
    const formData = Object.fromEntries(formDataObj);
    setSaving(true);

    try {
      const bind = {
        ...formData,
        status: 'OPEN',
        company_id: me.company.id,
        created_by: me.id,
        bot_id: bot?.id,
      };

      const card = await TicketApi.create(bind);

      history.push(`/chamados/${card.id}`);
    } catch (error) {
      console.error(error);
      NotificationHelper.snack('Falha ao criar chamado');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="container">
        <h3>Criar Chamado</h3>
      </div>

      <form className="container mt-4" id="form-item" onSubmit={onSubmit}>
        <div className="col-md-8 form-group mb-3">
          <label htmlFor="titleInput">{t('columns.title')}:</label>
          <input type="text" className="form-control" name="title" id="titleInput" required disabled={saving} />
        </div>

        <div className="col-md-8 form-group mb-3">
          <label htmlFor="descriptionInput">{t('columns.description')}:</label>
          <textarea className="form-control" name="description" id="descriptionInput" required disabled={saving}></textarea>
        </div>

        <div className="form-group mt-3 mb-4">
          <label htmlFor="selectsector">Informe qual o robô (opcional):</label>
          <BotSelect onChange={onBotChange} isDisabled={saving} />
        </div>

        <div className="text-right mb-5">
          <SubmitButton disabled={saving} className="btn btn-primary btn-lg" loading={saving} />
        </div>
      </form>
    </>
  );
};

export default withModalView(AddChamadoPage);
